import { FunctionComponent, useState } from 'react';
import classnames from 'classnames';
import { pictureFormat } from '@media-ui/core/src/components/Picture/Picture.format';
import getByPath from 'Tools/getByPath';
import { ConsultationListItemPropsExtended } from 'Components/ConsultationList/ConsultationList.types';
import type { IPictureFormatProps } from '@media-ui/core/src/components/Picture/Picture.format.types';
import { pushToWeborama } from 'Src/tools/weborama';
import { weboramaRequests } from 'Src/constants/weborama';
import { snitchCounter } from 'Tools/counters/snitchCounter';
import { FilterTabs } from '../FilterTabs/FilterTabs';
import ConsultationList from 'Components/ConsultationList';
import Button from '@media-ui/core/src/components/Button';
import { Icon20ChevronRight } from '@vkontakte/icons';
import * as s from './PetsConsultations.css';
import * as T from './PetsConsultations.types';
import Title from '@media-ui/core/src/components/Title';
import Wrapper from '@media-ui/core/src/components/Wrapper';
import { ITabsItemProps } from '@media-ui/core/src/components/Tabs/Tabs.types';
import { counterTrigger } from 'Src/tools/counters';
import classNames from 'classnames';
export const PetsConsultations: FunctionComponent<T.PetsConsultationsProps> = ({ object_list = [], rubric_list = [], isTouch = false, titleProps, className, title, urls, }) => {
    const [consultations, setConsultations] = useState(object_list);
    const [currentRubric, setCurrentRubric] = useState(rubric_list[0]?.slug);
    const filterItem = rubric_list.map((filter) => {
        return {
            title: filter.title,
            alias: filter.slug,
            ajax: filter.href,
            url: filter.href,
            active: filter.slug === currentRubric,
        };
    });
    const items: ConsultationListItemPropsExtended[] = consultations.map((item) => {
        const photo = getByPath('consultant.photo', item);
        const trtImage = getByPath('consultant.avatar', item);
        const images = trtImage?.page
            ? {
                ...trtImage.page,
                mobile: trtImage.small,
                tablet: trtImage.index,
                desktop: trtImage.page,
            }
            : null;
        const trtProps: IPictureFormatProps = {
            mobile: {
                dpr: 2,
                webp: true,
            },
            tablet: {
                dpr: 2,
                webp: true,
            },
            desktop: {
                dpr: 2,
                webp: true,
            },
        };
        const authorImg = images
            ? pictureFormat(images, trtProps)
            : {
                source: {
                    src: photo,
                },
            };
        return {
            text: item.description,
            authorUrl: item.consultant?.href,
            authorImg,
            authorName: item.consultant?.name,
            authorSpec: item.consultant?.position,
            url: item.href,
            title: item.title,
            classNameHeader: classnames(s.header, 'js-snitch-consult_ask_content'),
            classNameContent: classnames(s.content, 'js-snitch-consult_ask_content'),
            authorClb: 28643954,
            bodyClb: 28643971,
        };
    });
    const consultAskClasses = classnames(s.askButtonTop, 'js-snitch-consult_ask_question');
    /**
     * Обработчик кнопок смены типа консультаций
     */
    const handleConsultationTypeChange = (tabId: string, tabProps: ITabsItemProps & {
        ajax?: string;
    }) => {
        if (!tabProps.ajax)
            return;
        fetch(tabProps.ajax, {
            headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
        })
            .then((response) => response.json())
            .then((response) => {
            setCurrentRubric(response?.data.rubric.slug);
            setConsultations(response?.data.results || []);
            snitchCounter('consultWidgetFilter', {
                filterMode: tabId,
            });
        });
    };
    /**
     * Обработчик кнопки перехода на страницу консультации
     */
    const handlerClickAskButton = () => {
        pushToWeborama(weboramaRequests['consultation'], 'Yes');
        counterTrigger('consultationAskButton');
    };
    return (<div id="consultWidget" className={classNames(s.container, className)}>
      <Wrapper dataQaDetail="ContentLayout" className="wrapper" contentClassName={s.hdr}>
        <div className={s.textHeader}>
          <Title mediaLevel level="1" tag="h2" {...titleProps}>
            <a className={s.hdrLink} href={urls.title} onClick={() => counterTrigger('consultationHeaderClick')}>
              {title}
            </a>
          </Title>
          <div className={s.headerIcon}>
            <Icon20ChevronRight />
          </div>
        </div>
        {Boolean(rubric_list.length) && (<FilterTabs clickCounter="consultationFilterClick" changeLocation={false} className={s.filterWrap} items={filterItem} selectedTab={currentRubric} onChange={handleConsultationTypeChange}/>)}
        <Button.Link className={consultAskClasses} href={urls.ask} onClick={handlerClickAskButton} dataQa="AskButton">
          Спросить ветеринара
        </Button.Link>
      </Wrapper>
      <ConsultationList scrollPosition={0} classNameConsultationItem={s.rootItem} classNameScrollItem={s.scrollItem} className={s.rootList} items={items} isTouch={isTouch}/>
      <div className={s.askButtonBottom}>
        <a href={urls.ask}>
          <Button dataQa="AskButtonMobile" wide theme="primary">
            Спросить ветеринара
          </Button>
        </a>
      </div>
    </div>);
};
